export enum UserVerificationTelegramStep {
  intro = 'intro',
  onboarding = 'onboarding',
  pending = 'pending',
  completed = 'completed',
  done = 'done',
}
